export const DELIVERY_CHARGE = 2.99;

export * from "./pricing-plan-quantity";
